
import React, { useEffect, useRef, useState } from "react";
import DataTable from "datatables.net-react";
import DT from "datatables.net-dt";
import { Button } from "../StyledElements";
import { AssignCourseUsersDialog } from "../Dialogs/AssignCourseUsersDialog";

DataTable.use(DT);

const CourseUsersTable = ({ users = [], hideTitle = false, hideButtons = false, onUpdated = () => { }, mode = null, onSelect = () => { }, onFilter = () => { } }) => {
  const tableRef = useRef(null);
  const [localUsers, setLocalUsers] = useState(users);
  const [showAssignUserDialog, setShowAssignUserDialog] = useState(false);

  useEffect(() => {
    setLocalUsers(users);
    const publicIds = users.map((user) => user.public_id);
    onFilter(publicIds);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [users]);

  useEffect(() => {
    const interval = setInterval(() => {
      if (tableRef.current) {
        const dt = tableRef.current.dt();
        dt.on("search.dt", () => {
          const rows = dt.rows({ search: "applied" }).data().toArray();
          const publicIds = rows.map((row) => row[0]);
          onFilter(publicIds);
        });
        clearInterval(interval);
      } else {
        console.log("!!! TABLE REF IS NULL");
      }
    }, 10);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  window.formatDate = (date) => {
    const inputDate = new Date(date);

    const pad = (n) => n.toString().padStart(2, "0");

    const formattedDate =
      `${pad(inputDate.getDate())}-${pad(
        inputDate.getMonth() + 1
      )}-${inputDate.getFullYear()} ` +
      `${pad(inputDate.getHours())}:${pad(inputDate.getMinutes())}:${pad(
        inputDate.getSeconds()
      )} ` +
      `GMT${inputDate.toTimeString().slice(9, 14)} (${inputDate
        .toTimeString()
        .match(/\(([^)]+)\)/)[1]
        .split(" ")
        .map((w) => w[0])
        .join("")})`;
    return formattedDate;
  };



  window.selectedUsers = new Set();
  window.onSelectUsers = onSelect;

  const tableData = localUsers.map((user) => {
    return [
      user.email,
      `${user.firstname} ${user.lastname ?? ""}`,
      user.assigned_by,
      user.assigned_at ? new Date(user.assigned_at) : "",
    ]
  });

  return (
    <div style={{ width: "100%", position: "relative", paddingLeft: "20px", paddingRight: "20px" }}>
      <div style={{ display: "flex", flexDirection: "row", gap: "10px", alignItems: "center", justifyContent: "space-between", marginBottom: "20px" }}>
        <div style={{ fontSize: "16px", fontStyle: "italic", fontWeight: "normal" }}>
          {localUsers.length.toLocaleString()} users
        </div>
        <div>
          <Button
            onClick={() => {
              setShowAssignUserDialog(true);
            }}
          >+ Assign Course</Button>
        </div>
      </div>
      <DataTable
        ref={tableRef}
        data={tableData}
        className="display"
        style={{ width: "100%" }}
        options={{
          responsive: true,
          select: true,
          pageLength: 25,
          order: [[6, "desc"]],
        }}
      >
        <thead>
          <tr>
            <th>Email</th>
            <th>Name</th>
            <th>Assigned By</th>
            <th>Assigned At</th>
          </tr>
        </thead>
      </DataTable>
      <AssignCourseUsersDialog
        show={showAssignUserDialog}
        onClose={() => setShowAssignUserDialog(false)}
        onOK={() => setShowAssignUserDialog(false)}
        onAssignedUsers={(users) => {
          onUpdated(users);
          setShowAssignUserDialog(false);
        }}
        okText="Save"
        closeText="Close"
      />

    </div>
  );
};

export default CourseUsersTable;
